import {
  AfterViewInit,
  Directive,
  Output,
  EventEmitter,
  Host,
  Self,
  Optional,
} from "@angular/core";
import { ControlValueAccessor } from "@angular/forms";

import { BfxAmountSpinnerComponent } from "../../bfx-interface-controls/bfx-amount-spinner.component";
import { BfxRateSpinnerComponent } from "../../bfx-interface-controls/bfx-rate-spinner.component";
@Directive({
  selector: "[bfxmodelchangesubject]",
  standalone: false,
})
export class BfxModelChangeSubjectDirective implements AfterViewInit {
  private component: ControlValueAccessor;

  @Output() onModelChange: EventEmitter<any> = new EventEmitter();

  constructor(
    @Host() @Self() @Optional() amountComponent: BfxAmountSpinnerComponent,
    @Host() @Self() @Optional() rateComponent: BfxRateSpinnerComponent,
  ) {
    if (amountComponent != null) {
      this.component = amountComponent;
    } else if (rateComponent != null) {
      this.component = rateComponent;
    }
  }

  ngAfterViewInit() {
    let component = this.component;

    if (
      component != null &&
      typeof component === "object" &&
      component["registerOnChange"] != null &&
      typeof component["registerOnChange"] === "function"
    ) {
      this.component["registerOnChange"]((value) => {
        this.onModelChange.emit(value);
      });
    }
  }
}
